<template>
  <div class="content">
    <div class="line_bac"></div>
    <div class="header header1">
      <i class="el-icon-search"></i>
      <span class="title">运动区管理-查询</span>
    </div>
    <div class="query_con">
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item label="运动区名称">
          <el-input
            v-model="query.activityAreaName"
            placeholder="请输入运动区名称"
            style="width: 200px"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="所属活动室">
          <el-select
            v-model="query.activityRoomId"
            placeholder="请选择所属活动室"
            style="width: 200px"
            clearable
          >
            <el-option
              v-for="item in optionsType"
              :key="item.activityRoomId"
              :label="item.activityRoomName"
              :value="item.activityRoomId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-select
            v-model="query.status"
            placeholder="请选择是否启用"
            style="width: 200px"
          >
            <el-option
              v-for="item in optionsStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="query_btn">
        <el-button class="add" @click="queryParams">查询</el-button>
        <el-button class="add" @click="handleReset">重置</el-button>
      </div>
    </div>
    <div class="header">
      <i class="el-icon-date"></i>
      <span class="title">运动区列表</span>
    </div>
    <div class="operate">
      <el-button class="add" @click="addBadge">新增</el-button>
      <el-button class="add" @click="editBadge">修改</el-button>
      <el-button type="danger" @click="deleteBadge">删除</el-button>
    </div>
    <div class="table_con">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="tableLoading"
        :height="windowHeight"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <el-table-column
          prop="activityAreaName"
          label="运动区名称"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="name" label="所属活动室" align="center">
        </el-table-column>
        <el-table-column prop="sort" label="权重" align="center">
        </el-table-column>
        <el-table-column prop="status" label="是否启用" align="center">
          <template slot-scope="{ row }">
            <div>{{ row.status == 1 ? "启用" : "停用" }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="updateUserName" label="更新人" align="center">
        </el-table-column>
        <el-table-column prop="update_time" label="更新时间" align="center">
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination_con">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageData.page"
        :page-sizes="[20, 40, 60, 80, 100]"
        :page-size="pageData.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="`运动区${title}`"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
    >
      <div class="dialog_content">
        <el-form
          :model="form"
          label-width="100px"
          class="demo-form-inline"
          :rules="rules"
          ref="ruleForm"
        >
          <el-row style="flex-wrap: wrap" type="flex">
            <el-col :span="12">
              <el-form-item label="所属活动室" prop="activityRoomId">
                <el-select
                  v-model="form.activityRoomId"
                  placeholder="请选择所属活动室"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in optionsType"
                    :key="item.activityRoomId"
                    :label="item.activityRoomName"
                    :value="item.activityRoomId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12" v-if="title == '编辑'">
              <el-form-item label="是否启用" prop="status">
                <el-select
                  v-model="form.status"
                  placeholder="请选择是否启用"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in optionsStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="权重" prop="sort">
                <el-input
                  v-model="form.sort"
                  placeholder="请输入权重"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="运动区名称" prop="activityAreaName">
                <el-input
                  v-model="form.activityAreaName"
                  placeholder="请输入运动区名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否启用" prop="status">
                <el-select
                  v-model="form.status"
                  placeholder="请选择是否启用"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in optionsStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="权重" prop="sort">
                <el-input
                  v-model="form.sort"
                  placeholder="请输入权重"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="24">
              <el-form-item label="徽章图标" prop="iconId">
                <el-upload
                  :action="`${upload}/file/upload`"
                  list-type="picture-card"
                  :on-success="handleBeforeImage"
                  :on-remove="handleRemove"
                  :on-preview="previewBeforeImage"
                  :limit="1"
                  :file-list="beforeImageList"
                  accept=".jpg,.jpeg,.png"
                  :class="{ hide: hideUpload }"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </el-col> -->
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button class="add" @click="confirmSubmit">提交</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="deleteVisible" width="30%">
      <span>你确定要删除你选中的这条记录吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteVisible = false">取 消</el-button>
        <el-button class="add" @click="confirmDetele">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisibleImg">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import api from "@/apis/pcReservation";
export default {
  name: "badgeMaintain",
  data() {
    return {
      query: {
        activityAreaName: "",
        activityRoomId: "",
        status: "",
      },
      pageData: {
        page: 1,
        pageSize: 20,
      },
      total: 0,
      tableData: [],
      multipleSelection: [],
      tableLoading: false,
      windowHeight: 350,
      dialogVisible: false,
      form: {
        activityRoomId: "",
        status: 1,
        activityAreaName: "",
        // activityAreaName: '',
        sort: null,
      },
      rules: {
        activityRoomId: [
          { required: true, message: "请选择所属活动室", trigger: "change" },
        ],
        status: [
          { required: true, message: "请选择是否启用", trigger: "blur" },
        ],
        activityAreaName: [
          {
            required: true,
            trigger: "blur",
            message: "请输入运动室名称",
            // validator: this.validatePass,
          },
        ],
        // activityAreaName: [
        //   { required: true, trigger: "blur", validator: this.validateactivityAreaName },
        // ],
        sort: [
          {
            required: true,
            trigger: "blur",
            validator: this.validatesort,
          },
        ],
      },
      title: "新增",
      deleteVisible: false,
      itemId: "",
      optionsType: [],
      optionsStatus: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "是",
        },
        {
          value: 2,
          label: "否",
        },
      ],
      optionsStatusList: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 2,
          label: "否",
        },
      ],
      dialogImageUrl: "",
      dialogVisibleImg: false,
      medalTypeList: [],
    };
  },
  mounted() {
    // this.upload = api.upload;
    // this.imgUrl = api.imgUrl;
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.queryTypeList();
    this.queryData();
  },
  //销毁
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      // 使用 window.innerHeight 获取窗口的高度
      this.$nextTick(() => {
        this.windowHeight = window.innerHeight - 500;
      });
    },
    //验证活动室名称
    validatePass(rule, value, callback) {
      console.log(rule, value);
      if (!value) {
        callback(new Error("请输入运动区名称"));
      } else {
        if (this.title == "新增") {
          const typeName = this.tableData.filter(
            (item) => item.activityAreaName === value
          );
          if (typeName.length > 0) {
            callback(new Error("运动区名称不能重复"));
          } else {
            callback();
          }
        } else {
          const typeName = this.tableData.filter(
            (item) => item.id != this.itemId
          );
          const typeNameList = typeName.filter(
            (item) => item.activityAreaName === value
          );

          if (typeNameList.length > 0) {
            callback(new Error("运动区名称不能重复"));
          } else {
            callback();
          }
        }
      }
    },
    //验证运动区名称
    validateactivityAreaName(rule, value, callback) {
      console.log(rule, value);
      if (!value) {
        callback(new Error("请输入运动区名称"));
      } else {
        value = value.toString();
        var reg = /^((?!0)\d{1,9})$/;
        if (!value.match(reg)) {
          this.form.activityAreaName = null;
          callback(new Error("运动区名称请输入正整数"));
        } else {
          callback();
        }
      }
    },
    //验证权重
    validatesort(rule, value, callback) {
      console.log(rule, value);
      if (!value) {
        callback(new Error("请输入权重"));
      } else {
        value = value.toString();
        var reg = /^((?!0)\d{1,9})$/;
        if (!value.match(reg)) {
          this.form.sort = null;
          callback(new Error("权重请输入正整数"));
        } else {
          callback();
        }
      }
    },
    queryParams() {
      this.queryData();
    },
    //重置查询条件
    handleReset() {
      this.query = {
        activityAreaName: "",
        activityRoomId: "",
        status: "",
      };
      this.queryData();
    },
    // 选择table
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //分页
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.queryData();
    },
    //页码改变
    handleCurrentChange(val) {
      this.pageData.page = val;
      this.queryData();
    },
    //取消新增编辑弹框
    handleClose() {
      this.dialogVisible = false;
      this.$refs.ruleForm.resetFields();
      this.itemId = "";
    },
    // 显示 新增
    addBadge() {
      this.title = "新增";
      this.form = {};
      // this.form.activityRoomId=''
      this.dialogVisible = true;
      this.$refs.ruleForm?.resetFields();
    },
    //显示 编辑
    editBadge() {
      if (this.multipleSelection.length == 1) {
        this.form = {
          activityRoomId: this.multipleSelection[0].activityRoomId,
          status: this.multipleSelection[0].status
            ? this.multipleSelection[0].status
            : 1,
          // activityAreaName: this.multipleSelection[0].activityAreaName,
          activityAreaName: this.multipleSelection[0].activityAreaName,
          sort: this.multipleSelection[0].sort,
        };
        this.itemId = this.multipleSelection[0].id;
        this.title = "编辑";
        this.dialogVisible = true;
      } else if (this.multipleSelection.length > 1) {
        return this.$message({
          message: "请选择一条类别进行编辑",
          type: "warning",
        });
      } else {
        return this.$message({
          message: "请选择需要编辑的类别",
          type: "warning",
        });
      }
    },
    // 确认新增 编辑
    confirmSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.title == "编辑") {
            this.form.id = this.multipleSelection[0].id;
          }
          console.log(this.form, "this.form");
          api.addOrUpdateArea({ ...this.form }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: this.title + "成功",
                type: "success",
              });
              this.itemId = "";
              this.dialogVisible = false;
              this.queryData();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 显示 删除弹框
    deleteBadge() {
      if (this.multipleSelection.length >= 1) {
        for (let i = 0; i < this.multipleSelection.length; i++) {
          if (this.multipleSelection[i].status == 1) {
            return this.$message({
              message: "启用状态的记录无法删除！",
              type: "warning",
            });
          }
        }
        this.deleteVisible = true;
        // if (this.multipleSelection[0].status == 1) {
        //   return this.$message({
        //     message: "启用状态的记录无法删除！",
        //     type: "warning",
        //   });
        // } else {
        //   this.deleteVisible = true;
        // }
      } else {
        return this.$message({
          message: "请选择需要删除的类别",
          type: "warning",
        });
      }
    },
    //确认删除
    confirmDetele() {
      let ids = []
      this.multipleSelection.forEach(item=>{
        ids.push(item.id)
      })
      api.batchDeleteArea({ ids:ids }).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.deleteVisible = false;
          this.queryData();
        }
      });
    },
    //活动室类别列表
    queryTypeList() {
      api.queryActivityRoom({ page: 1, pageSize: 500 }).then((res) => {
        if (res.code == 200) {
          this.optionsType = res.data.data;
          console.log(this.optionsType, "this.optionsType");
        }
      });
    },
    // 查询 列表
    queryData() {
      const json = {
        ...this.pageData,
        ...this.query,
      };
      api.queryActivityAreaPage(json).then((res) => {
        console.log(res, "res");
        if (res.code == 200) {
          this.tableData = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    // 改变所属活动室
    // handleActivityRoomName() {
    //   api
    //     .queryByPageList({
    //       page: 1,
    //       pageSize: 500,
    //       activityRoomId: this.form.activityRoomId,
    //     })
    //     .then((res) => {
    //       if (res.code == 200) {
    //         this.medalTypeList = res.data;
    //       }
    //     });
    // },
  },
};
</script>

<style lang="scss" scoped>
.content {
  background-color: #f2fcf9;
  height: 100%;
  .line_bac {
    width: 100%;
    height: 20px;
    background-color: #00ada7;
  }
  .header1 {
    border-bottom: 4px solid #d0d1d1;
  }
  .header {
    width: 100%;
    height: 90px;
    line-height: 90px;
    background-color: #efefef;
    font-size: 29px;
    ::v-deep {
      .el-icon-date {
        color: #00ada7;
        margin: 0 10px 0 40px;
      }
      .el-icon-search {
        color: #00ada7;
        margin: 0 10px 0 40px;
      }
    }
    .title {
      color: #00ada7;
    }
  }
  .query_con {
    margin: 30px 40px 20px 40px;
    padding: 40px 0 50px 40px;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
    .query_btn {
      margin-top: 30px;
      display: flex;
      justify-content: flex-end;
      margin-right: 100px;
      .add {
        color: #fff;
        background-color: #23c0d8;
      }
    }
  }
  .operate {
    margin: 20px 40px;
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  .table_con {
    background-color: #fff;
    border: 1px solid #e2e6e5;
    padding: 40px 20px;
    margin: 0 40px;
    border-radius: 5px;
  }
  .pagination_con {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    padding-right: 40px;
  }
  .dialog-footer {
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  ::v-deep .hide .el-upload--picture-card {
    display: none;
  }
}
</style>
